/* tslint:disable */
/* eslint-disable */
/**
 * Bulletin API
 * REST API for Bulletin platform
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UtmParams } from './UtmParams';
import {
    UtmParamsFromJSON,
    UtmParamsFromJSONTyped,
    UtmParamsToJSON,
} from './UtmParams';

/**
 * 
 * @export
 * @interface ApplyToSellDetailsResponse
 */
export interface ApplyToSellDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellDetailsResponse
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellDetailsResponse
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellDetailsResponse
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellDetailsResponse
     */
    brand_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellDetailsResponse
     */
    website_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellDetailsResponse
     */
    shipping_city?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellDetailsResponse
     */
    years_in_business?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplyToSellDetailsResponse
     */
    onboard_complete?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellDetailsResponse
     */
    phone_number?: string;
    /**
     * 
     * @type {UtmParams}
     * @memberof ApplyToSellDetailsResponse
     */
    utm_params?: UtmParams;
}

/**
 * Check if a given object implements the ApplyToSellDetailsResponse interface.
 */
export function instanceOfApplyToSellDetailsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApplyToSellDetailsResponseFromJSON(json: any): ApplyToSellDetailsResponse {
    return ApplyToSellDetailsResponseFromJSONTyped(json, false);
}

export function ApplyToSellDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplyToSellDetailsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'brand_name': !exists(json, 'brand_name') ? undefined : json['brand_name'],
        'website_url': !exists(json, 'website_url') ? undefined : json['website_url'],
        'shipping_city': !exists(json, 'shipping_city') ? undefined : json['shipping_city'],
        'years_in_business': !exists(json, 'years_in_business') ? undefined : json['years_in_business'],
        'onboard_complete': !exists(json, 'onboard_complete') ? undefined : json['onboard_complete'],
        'phone_number': !exists(json, 'phone_number') ? undefined : json['phone_number'],
        'utm_params': !exists(json, 'utm_params') ? undefined : UtmParamsFromJSON(json['utm_params']),
    };
}

export function ApplyToSellDetailsResponseToJSON(value?: ApplyToSellDetailsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first_name': value.first_name,
        'last_name': value.last_name,
        'email': value.email,
        'brand_name': value.brand_name,
        'website_url': value.website_url,
        'shipping_city': value.shipping_city,
        'years_in_business': value.years_in_business,
        'onboard_complete': value.onboard_complete,
        'phone_number': value.phone_number,
        'utm_params': UtmParamsToJSON(value.utm_params),
    };
}

